import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';

const config = {
  apiKey: 'hbp_JgKQY7hQoRYVSvcWbQDtqtH02OS0up0mqGWi',
  endpoint: 'https://eu-api.honeybadger.io',
  environment: process.env.NODE_ENV ?? 'production',
};

const honeybadger = Honeybadger.configure(config);

export default function HoneybadgerWrapper({ children }) {
  // disable this behaviour until we can get proper tracking on all the anonymous errors
  // return <HoneybadgerErrorBoundary honeybadger={honeybadger}>{children}</HoneybadgerErrorBoundary>;

  return <>{children}</>;
}
